const extractCodeContent = (htmlString) => {
    const parser = new DOMParser();
    const htmlFromString = parser.parseFromString(htmlString, 'text/html');
    const codeTags = htmlFromString.querySelectorAll('code');
    return Array.from(codeTags).map((el) => el.textContent);
  };
  
  const copyText = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
    } catch (err) {
      console.log(err);
      throw Error('Failed to copy');
    }
  };
  
  export { extractCodeContent, copyText };